import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { INGRESOALMACENPORODENCOMPRA_LISTA, INGRESOALMACENPORODENCOMPRA_NUEVA } from 'constants/codigosTransacciones'

import ListaPage from './lista'
import NuevaPage from './nueva'

export default function IngresoAlmacenOrdenCompraPages() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${INGRESOALMACENPORODENCOMPRA_LISTA}`} component={ListaPage} />
        <Route path={`/${INGRESOALMACENPORODENCOMPRA_NUEVA}`} component={NuevaPage} />
      </Switch>
    </Suspense>
  )
}
